import { jsx as r } from "react/jsx-runtime";
import { chakra as R, useMultiStyleConfig as P, Box as g } from "@chakra-ui/react";
import { forwardRef as m, useRef as N, useCallback as k } from "react";
import c from "react-datepicker";
import { CustomHeader as A } from "./components/CustomHeader.mjs";
import { CustomInput as T } from "./components/CustomInput.mjs";
const b = c.default ? c.default : c, u = m(
  ({ className: s, ...l }, e) => /* @__PURE__ */ r(b, { calendarClassName: s, ref: e, ...l })
);
u.displayName = "DatePickerAdapter";
const x = R(u, {
  baseStyle: {}
}), I = m((s, l) => {
  const {
    datePickerOptions: e,
    value: f,
    onChange: o,
    "data-testid": n,
    showTodayButton: y = !0,
    isReadOnly: p,
    isDisabled: D,
    ...h
  } = s, w = P("DatePicker", {}), i = N(), C = k(
    (a) => {
      const t = a.currentTarget.value;
      if (t)
        if (t.match(/yyyy\/mm\/dd/gi))
          o(null, a);
        else {
          const d = new Date(
            t.replaceAll("D", "").replaceAll("M", "").replaceAll("Y", "")
          );
          d instanceof Date && !isNaN(d) && o(d, a);
        }
    },
    [o]
  );
  return /* @__PURE__ */ r(g, { children: /* @__PURE__ */ r(
    x,
    {
      ref: i,
      dateFormat: "yyyy/MM/dd",
      showPopperArrow: !1,
      onChangeRaw: C,
      onChange: o,
      __css: w.container,
      selected: f,
      "data-testid": n,
      ...e,
      readOnly: p,
      disabled: D,
      todayButton: y ? "Today" : void 0,
      onKeyDown: (a) => {
        var t;
        a.code === "Tab" && a.shiftKey && a.target.nodeName == "INPUT" && ((t = i.current) == null || t.setOpen(!1));
      },
      renderCustomHeader: (a) => /* @__PURE__ */ r(
        A,
        {
          ...a,
          dataTestId: n,
          minDate: e == null ? void 0 : e.minDate,
          maxDate: e == null ? void 0 : e.maxDate
        }
      ),
      customInput: /* @__PURE__ */ r(T, { ...h, "data-testid": n, ref: l })
    }
  ) });
});
I.displayName = "DatePicker";
export {
  I as DatePicker
};
